import MyGroup from './my-group'

export default MyGroup
